import { configureStore } from "@reduxjs/toolkit";
import { applyMiddleware } from "redux";
import thunk from "redux-thunk";
import settingReducer from "./setting/reducers";
import authReducer from "./auth/reducer";
import adminAuthReducer from "./adminAuth/reducer";
export const store = configureStore({
  reducer: {
    setting: settingReducer,
    auth: authReducer,
    adminAuth: adminAuthReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});
